export const GET_TAGSANDFAVS = "GET_TAGSANDFAVS";
export const SET_TAGSANDFAVS = "SET_TAGSANDFAVS";
export const RESET_TAGSANDFAVS = "RESET_TAGSANDFAVS";
